import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { Menu, X } from "lucide-react";
import { trackCustomEvent } from "../utils/metaPixel";
import { unregisterPush } from "../utils/pushToken";

export default function Navbar() {
  const navigate = useNavigate();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // 🔹 Get logged-in user from storage
  const storedUser =
    JSON.parse(sessionStorage.getItem("user")) ||
    JSON.parse(localStorage.getItem("user")) ||
    null;

  const token = storedUser?.token || null;
  const role = storedUser?.role || null;

  const handleLogoClick = () => {
    if (token) {
      if (role === "user") navigate("/user/dashboard");
      else if (role === "astrologer") navigate("/astrologer/dashboard");
      else if (role === "admin") navigate("/admin/dashboard");
    } else {
      navigate("/");
    }
  };

  const handleLogout = async () => {
    // Stop notifications for this device. Must run BEFORE the session is cleared
    // (it needs the login token). It never throws, so logout always continues.
    await unregisterPush(storedUser);

    sessionStorage.removeItem("user");
    localStorage.removeItem("user");
    navigate("/login");
  };

  return (
    <>
      <nav className="bg-white shadow-md fixed w-full top-0 left-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3 md:py-4 flex items-center justify-between">
          {/* Logo */}
          <span
            onClick={handleLogoClick}
            className="cursor-pointer flex items-center gap-2"
          >
            <img
              src="/Astroseven-logo.png"
              alt="Logo"
              className="h-10 w-10 rounded-full object-cover"
            />
            <div className="flex flex-col">
              <span className="text-xl md:text-2xl font-bold text-orange-500">
                Astro Seven
              </span>
              <span className="text-xs md:text-sm text-gray-500 font-medium">
                मन शांत तो जीवन संतुलित
              </span>
            </div>
          </span>

          {/* Desktop Links */}
          <div className="hidden md:flex items-center gap-6">
            {!token ? (
              <>
                <Link
                  to="/"
                  className="text-gray-700 hover:text-purple-700 font-medium"
                >
                  Home
                </Link>
                <Link
                  to="/login"
                  className="text-gray-700 hover:text-purple-700 font-medium"
                >
                  Login
                </Link>
                <Link
                  to="/user/register"
                  className="text-gray-700 hover:text-purple-700 font-medium"
                >
                  Sign up
                </Link>
                <Link
                  to="/astrologer/register"
                  className="text-gray-700 hover:text-purple-700 font-medium"
                >
                  Astrologer Register
                </Link>
              </>
            ) : (
              <>
                <Link
                  to="/user/wallet"
                  className="text-gray-700 hover:text-purple-700 font-medium"
                >
                  Wallet
                </Link>
                <button
                  onClick={handleLogout}
                  className="text-gray-700 hover:text-red-600 font-medium"
                >
                  Logout
                </button>
              </>
            )}
          </div>

          {/* Mobile: Free Chat button + Hamburger */}
          <div className="md:hidden flex items-center gap-3">
            {(!token || role === "user") && (
              <Link
                to={token ? "/ai-consultancy" : "/user/register"}
                onClick={() =>
                  trackCustomEvent("FreeChatCTA", { placement: "navbar" })
                }
                className="rounded-full bg-gradient-to-b from-amber-300 to-amber-500 px-3.5 py-2 text-sm font-bold text-slate-900 shadow"
              >
                Free Chat
              </Link>
            )}
            <button
              className="text-gray-700"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>

        {/* Mobile Dropdown */}
        {isMenuOpen && (
          <div className="md:hidden bg-white shadow-md px-6 py-6 flex flex-col gap-4">
            <Link to="/free-kundali" onClick={() => setIsMenuOpen(false)}>
              Free Kundli
            </Link>
            <Link to="/horoscopes" onClick={() => setIsMenuOpen(false)}>
              Daily Horoscope
            </Link>
            <Link to="/match-making" onClick={() => setIsMenuOpen(false)}>
              Matchmaking
            </Link>
            <Link to="/shopping" onClick={() => setIsMenuOpen(false)}>
              Shop
            </Link>
            <Link to="/occult" onClick={() => setIsMenuOpen(false)}>
              Courses
            </Link>
            <hr className="my-2 border-gray-200" />

            {!token ? (
              <>
                <Link to="/login" onClick={() => setIsMenuOpen(false)}>
                  Login
                </Link>
                <Link to="/user/register" onClick={() => setIsMenuOpen(false)}>
                  Sign up
                </Link>
                <Link
                  to="/astrologer/register"
                  onClick={() => setIsMenuOpen(false)}
                >
                  Astrologer Register
                </Link>
              </>
            ) : (
              <>
                <Link to="/user/wallet" onClick={() => setIsMenuOpen(false)}>
                  Wallet
                </Link>
                <button
                  onClick={() => {
                    handleLogout();
                    setIsMenuOpen(false);
                  }}
                  className="text-left text-gray-700 hover:text-red-600 font-medium"
                >
                  Logout
                </button>
              </>
            )}
          </div>
        )}
      </nav>
      <div className="pt-[68px] md:pt-20"></div>
    </>
  );
}